import React, { Component } from 'react';
import { connect } from "react-redux";
import SaveLoader from "../../components/loader/SaveLoader";
import { Button, Row, Input, Card, CardBody, Col, Label } from "reactstrap";
import 'react-credit-cards/es/styles-compiled.css';
import axios from "axios";
// import qs from 'qs';
import Steppers from "../../components/search/Steppers";
import { API_URL } from "../../config/Config";
// import { ACCESS_TOKEN } from "../../redux/actions/setting";
import { setBusIssue } from "../../redux/actions/ticket";
import { countryCode } from "./../../redux/utils/countryCode";
import Select from 'react-select';



class Paymentgetway extends Component {
    constructor(props) {
        super(props);
        let country = countryCode.map(item => {
            return {
                value: (item.symbol).substring(0, 2),
                label: item.NAME
            };
        });

        this.state = {
            loading: false,
            country: country,
            selectedCountry: null,
            firstName: null,
            lastName: null,
            mobile: null,
            email: null,
            address: null,
            postalCode: null,
            city: null,
            description: null,
        }
        this.handelPayment = this.handelPayment.bind(this);
    }


    async handelPayment(e) {
        e.preventDefault();
        const { firstName, lastName, email, mobile, address, postalCode, description, selectedCountry, city } = this.state;
        await this.setState({ loading: true });
        const formData = new FormData();
        formData.append('user_id', this.props.ticket.reserved_ticket.reserve.user_id);
        formData.append('altrabo_token', this.props.ticket.reserved_ticket.reserve.altrabo_token);
        formData.append('user_ticket_id', this.props.ticket.reserved_ticket.reserve.user_ticket_id);
        formData.append('ExternalBookIds', this.props.ticket.reserved_ticket.reserve.ExternalBookIds);
        formData.append('ticket_type', this.props.ticket.reserved_ticket.reserve.ticket_type);

        formData.append('firstName', firstName);
        formData.append('lastName', lastName);
        formData.append('email', email);
        formData.append('mobile', mobile);
        formData.append('address', address);
        formData.append('postalCode', postalCode);
        formData.append('description', description);
        formData.append('city', city);
        formData.append('country', selectedCountry.label);

        let issue;
        try {
            issue = await axios.post(API_URL + 'Payment', formData)
            console.log(issue);
            if (issue.data.status === 0) {
                alert(issue.data.message);
            } else {
                this.props.setBusIssue(issue.data.results);
                alert("Thank you For choosing us you can Pay your ticket in next page")
                window.location.replace(issue.data);
            }
        } catch (err) {
            console.log('error');
            console.log(err);
            if (err.response.data.massage) {
                alert(err.response.data.massage);
            } else {
                alert('there is a problem getting this ticket please try another one');
            }
            // window.location.replace('/search-bus');
        }
        await this.setState({ loading: false });
    }
    handleChangeCountry(selectedCountry) {
        console.log(selectedCountry);
        this.setState({ selectedCountry: selectedCountry })
    }
    async handelForm(e) {
        console.log(e.target.value);
        const value = e.target.value;
        const name = e.target.name;
        switch (name) {
            case 'firstName':
                await this.setState({ firstName: value });
                break;
            case 'lastName':
                await this.setState({ lastName: value });
                break;
            case 'mobile':
                await this.setState({ mobile: value });
                break;
            case 'email':
                await this.setState({ email: value });
                break;
            case 'address':
                await this.setState({ address: value });
                break;
            case 'postalCode':
                await this.setState({ postalCode: value });
                break;
            case 'city':
                await this.setState({ city: value });
                break;
            case 'description':
                await this.setState({ description: value });
                break;
            default:
                return true;
        }
    }

    render() {
        // console.log(this.props.ticket.reserved_ticket.reserve)
        return (
            <div className="Ticketreview pt-5 mt-5 payment-getway">
                {this.state.loading && <SaveLoader />}
                <Row>
                    <Col >
                        <div className="white box search-progress">
                            <Steppers active={3} />
                        </div>
                    </Col>
                </Row>
                <Card>
                    <CardBody>

                        <div className="payment-form">

                            <form onSubmit={this.handelPayment} className='payment-form'>
                                <Row>
                                    <Col md={3} sm={6}>
                                        <Label for="name">First Name : </Label>
                                        <Input name="firstName" id="firstName" placeholder='First Name' className='email-input' required onChange={this.handelForm.bind(this)} />
                                    </Col>
                                    <Col md={3} sm={6}>
                                        <Label for="name">Last Name : </Label>
                                        <Input name="lastName" id="lastName" placeholder='Last Name' className='email-input' required onChange={this.handelForm.bind(this)} />
                                    </Col>
                                    <Col md={3} sm={6}>
                                        <Label for="name">Mobile Number : </Label>
                                        <Input type="number" name="mobile" id="mobile" placeholder='mobile number' className='email-input' required onChange={this.handelForm.bind(this)} />
                                    </Col>
                                    <Col md={3} sm={6}>
                                        <Label for="name">Email : </Label>
                                        <Input type="email" name="email" id="email" placeholder='email@example.com' className='email-input' onChange={this.handelForm.bind(this)} required />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3} sm={6}>
                                        <Label for="name">Address : </Label>
                                        <Input name="address" id="address" placeholder='Address' className='email-input' required onChange={this.handelForm.bind(this)} />
                                    </Col>
                                    <Col md={3} sm={6}>
                                        <Label for="name">Postal Code : </Label>
                                        <Input type='number' name="postalCode" id="postalCode" placeholder='Postal Code' className='email-input' required onChange={this.handelForm.bind(this)} />
                                    </Col>
                                    <Col md={3} sm={6}>
                                        <Label for="name">Select Country : </Label>
                                        <Select
                                            className="select-country"
                                            placeholder="Country"
                                            isSearchable={true}
                                            name="DocIssuedCountry"
                                            value={this.state.selectedCountry}
                                            onChange={this.handleChangeCountry.bind(this)}
                                            options={this.state.country}
                                        />
                                    </Col>
                                    <Col md={3} sm={6}>
                                        <Label for="name">City : </Label>
                                        <Input name="city" id="city" placeholder='City' className='email-input' required onChange={this.handelForm.bind(this)} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3} sm={6}>
                                        <Label for="name">Description : </Label>
                                        <Input name="description" id="description" placeholder='Description' className='email-input' required onChange={this.handelForm.bind(this)} />
                                    </Col>
                                </Row>
                                <Button type='submit' className='pay-it-but' >Pay</Button>
                            </form>
                        </div>
                    </CardBody>
                </Card>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        ticket: state.ticket
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setBusIssue: (ticket) => {
            dispatch(setBusIssue(ticket))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Paymentgetway)



// WEBPACK FOOTER //
// ./src/containers/search/Paymentgateway.jsx